import CustomCarousel from '~/client/shared/Carousel/CustomCarousel';
import GameCard from '~/client/shared/game/GameCard';
import useGameCardSize from '~/client/shared/game/GameCard/useGameCardSize';
import CarouselPlaceholder from '~/client/shared/LazyLoad/Placeholder/CaroulselPlaceholder';
import PageSection from '~/client/shared/PageSection';
import useFavouritesSlider from './useFavouritesSlider';

type Props = { big?: boolean };

const FavouritesSlider: FC<Props> = ({ big }) => {
  const { myFavourites, loading } = useFavouritesSlider();
  const { height, width } = useGameCardSize();
  const href = '/games/favourite';
  const titleId = 'casino.favourite_games';

  if (loading) {
    return <CarouselPlaceholder width={width} height={height} href={href} />;
  }

  if (!myFavourites?.length) {
    return null;
  }

  const items = myFavourites?.map(({ node }) => {
    if (!node) {
      return null;
    }
    return (
      <GameCard
        key={node.id}
        game={node}
        big={big}
        isCarousel
        sourcePage="game_page"
      />
    );
  });

  return (
    <PageSection titleId={titleId} href={href} id="favourites">
      <CustomCarousel items={items ?? []} />
    </PageSection>
  );
};

export default FavouritesSlider;
